module.exports = "https://web-assets.ifttt.com/packs/media/access_applet_card/mail-app-31d6cfe0.svg";